import React, { forwardRef, useEffect, useState } from 'react'
import { Select } from '@arco-design/web-react'
import { IconSearch } from '@arco-design/web-react/icon'
export const SelectForm = forwardRef((props, ref) => {
  const {
    selectform,
    getValue,
    labelFieldName,
    valueFieldName,
    options,
    ...rest
  } = props
  const { disabled } = rest
  const [triggerShow, setTriggerShow] = useState(null)
  const [innerOptions, setInnerOptions] = useState([])
  const Form = disabled ? undefined : selectform?.Form
  const multiple = selectform?.multiple
  const deptKey = selectform?.deptKey
  useEffect(() => {
    setInnerOptions(options ?? [])
  }, [options])
  const onShowDialog = () => {
    setTriggerShow(false)
  }
  return (
    <>
      <Select
        ref={ref}
        options={innerOptions}
        {...rest}
        popupVisible={false}
        onClick={(e) => {
          !disabled && setTriggerShow({ ...{} })
          e.stopPropagation()
        }}
        arrowIcon={<IconSearch />}
        renderFormat={
          getValue
            ? (option, value) => {
                return getValue(value, option?.extra)
              }
            : (option) => {
                return option?.extra?.[labelFieldName] ?? ''
              }
        }
      />
      {Form && (
        <Form
          {...selectform}
          triggerShow={triggerShow}
          onShowDialog={onShowDialog}
          onChoice={(items) => {
            const newInnerOptions = [...innerOptions]
            items.forEach((item) => {
              if (
                !newInnerOptions.find((c) => c.value == item[valueFieldName])
              ) {
                newInnerOptions.push({
                  extra: item,
                  value: item[valueFieldName],
                  label: item[labelFieldName],
                })
              }
            })
            setInnerOptions(newInnerOptions)
            selectform && selectform.onChoice(items)
          }}
          multiple={multiple}
          deptKey={deptKey}
        />
      )}
    </>
  )
})
